export default __webpack_public_path__ + "static/media/AngeletteTurne.b2538d54.pdf";